(function () {
  if (window.__wsmLandingCtaCardRuntime) return;
  window.__wsmLandingCtaCardRuntime = true;

  var root = document.querySelector("[data-wsm-landing-cta]");
  if (!root) return;

  var shell = document.querySelector(".wsm-v15-visual-shell");
  var configuredSeconds = shell
    ? parseInt(shell.getAttribute("data-wsm-countdown-seconds"), 10)
    : NaN;
  var totalSeconds =
    Number.isFinite(configuredSeconds) && configuredSeconds > 0
      ? configuredSeconds
      : 11 * 60 * 60 + 47 * 60 + 50;
  var timer = root.querySelector("#countdownTimer");
  var finalTimer = document.getElementById("countdownTimerFinal");
  var midTimer = document.getElementById("countdownTimerMid");
  var mobileTimer = document.getElementById("mobileCountdownTimer");
  var rail = root;
  var hero = rail.closest(".hero") || document.querySelector(".hero");
  var stopElement =
    document.querySelector(".final-cta") || document.querySelector("footer");
  var originalTop = 0;
  var originalWidth = 360;
  var timerId = 0;

  function hasActiveOneTimeOffer() {
    try {
      return !!(
        window.WSMV3DOneTimeOffer &&
        typeof window.WSMV3DOneTimeOffer.getActiveOffer === "function" &&
        window.WSMV3DOneTimeOffer.getActiveOffer()
      );
    } catch (error) {
      return false;
    }
  }

  function renderTimer() {
    // The one-time-offer renderer intentionally owns these timer IDs while active.
    // The canonical CTA timer resumes automatically when that offer is no longer active.
    if (hasActiveOneTimeOffer()) return;

    var hours = Math.floor(totalSeconds / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;
    var text =
      String(hours).padStart(2, "0") +
      "h : " +
      String(minutes).padStart(2, "0") +
      "m : " +
      String(seconds).padStart(2, "0") +
      "s";

    if (timer) timer.textContent = text;
    if (finalTimer) finalTimer.textContent = text;
    if (midTimer) midTimer.textContent = text;
    if (mobileTimer) mobileTimer.textContent = text;
    if (totalSeconds > 0) totalSeconds -= 1;
  }

  function resetRail() {
    rail.classList.remove("is-fixed", "is-bottomed");
    rail.style.left = "";
    rail.style.top = "";
    rail.style.width = "";
  }

  function measure() {
    if (!hero) return;
    resetRail();
    var rect = rail.getBoundingClientRect();
    originalTop = rect.top + window.scrollY;
    originalWidth = rect.width;
  }

  function updateSticky() {
    if (!hero) return;
    if (window.innerWidth <= 1120) {
      resetRail();
      return;
    }

    var scrollY = window.scrollY || window.pageYOffset;
    var fixedTop = document.body.classList.contains("course-subnav-active")
      ? 72
      : 88;
    var stopTop = stopElement
      ? stopElement.getBoundingClientRect().top + scrollY
      : document.body.scrollHeight;
    var stopY = stopTop - rail.offsetHeight - 28;

    if (scrollY + fixedTop < originalTop) {
      resetRail();
      return;
    }

    if (scrollY + fixedTop >= stopY) {
      rail.classList.remove("is-fixed");
      rail.classList.add("is-bottomed");
      rail.style.left = "";
      rail.style.top = stopY + "px";
      rail.style.width = originalWidth + "px";
      return;
    }

    rail.classList.remove("is-bottomed");
    rail.classList.add("is-fixed");
    rail.style.left = "";
    rail.style.top = fixedTop + "px";
    rail.style.width = originalWidth + "px";
  }

  function refresh() {
    measure();
    updateSticky();
  }

  renderTimer();
  timerId = window.setInterval(renderTimer, 1000);
  refresh();

  window.addEventListener("load", refresh, { passive: true });
  window.addEventListener("pageshow", refresh, { passive: true });
  window.addEventListener("resize", refresh, { passive: true });
  window.addEventListener("orientationchange", refresh, { passive: true });
  window.addEventListener("scroll", updateSticky, { passive: true });
  document.addEventListener("wsm:cta:refresh", refresh);

  window.WSMLandingCtaCard = {
    refresh: refresh,
    stopTimer: function () {
      if (timerId) window.clearInterval(timerId);
      timerId = 0;
    },
  };
})();
